export const marketingConstants = {
    UPDATE_MARKETING_DATA: 'UPDATE_MARKETING_DATA',
    SALON_MARKETING_SETTING: 'SALON_MARKETING_SETTING',
    NAVIGATION_MARKETING_SETTING: 'NAVIGATION_MARKETING_SETTING',
}
